export var getDisplayDecimal = function getDisplayDecimal(number, decimals) {
  return number.toLocaleString('es-ES', {
    style: 'decimal',
    maximumFractionDigits: decimals
  });
};